import { render, staticRenderFns } from "./ApproveTransferStock.vue?vue&type=template&id=0256ea41"
import script from "./ApproveTransferStock.vue?vue&type=script&lang=js"
export * from "./ApproveTransferStock.vue?vue&type=script&lang=js"
import style0 from "./ApproveTransferStock.vue?vue&type=style&index=0&id=0256ea41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports